"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const C2dShader_1 = require("../C2dShader");
const ColorUtils_1 = require("../../../tree/ColorUtils");
class C2dDefaultShader extends C2dShader_1.C2dShader {
    constructor() {
        super(...arguments);
        this._rectangleTexture = this.context.stage.rectangleTexture.getUpdatedSource().nativeTexture;
        this._tintManager = this.context.stage.renderer.tintManager;
    }
    draw(operation, target) {
        const length = operation.length;
        for (let i = 0; i < length; i++) {
            const tx = operation.getTexture(i);
            const elementCore = operation.getElementCore(i);
            const rc = operation.getRenderContext(i);
            const white = operation.getWhite(i);
            const stc = operation.getSimpleTc(i);
            const context = target.context;
            const pixelRatio = this.context.stage.getPixelRatio();
            context.setTransform(rc.ta * pixelRatio, rc.tc * pixelRatio, rc.tb * pixelRatio, rc.td * pixelRatio, rc.px * pixelRatio, rc.py * pixelRatio);
            const rect = tx === this._rectangleTexture;
            const info = { operation, target, index: i, rect };
            if (rect) {
                // Check for gradient.
                if (white) {
                    context.fillStyle = "white";
                }
                else {
                    this._setColorGradient(context, elementCore);
                }
                context.globalAlpha = rc.alpha;
                this._beforeDrawEl(info);
                context.fillRect(0, 0, elementCore.getLayoutW(), elementCore.getLayoutH());
                this._afterDrawEl(info);
                context.globalAlpha = 1.0;
            }
            else {
                // @todo: set image smoothing based on the texture.
                // @todo: optimize by registering whether identity texcoords are used.
                context.globalAlpha = rc.alpha;
                this._beforeDrawEl(info);
                // @todo: test if rounding yields better performance.
                // Notice that simple texture coords can be turned on even though vc._ulx etc are not simple, because
                //  we are rendering a render-to-texture (texcoords were stashed). Same is true for 'white' color btw.
                const sourceX = stc ? 0 : elementCore.ulx * tx.w;
                const sourceY = stc ? 0 : elementCore.uly * tx.h;
                const sourceW = (stc ? 1 : elementCore.brx - elementCore.ulx) * tx.w;
                const sourceH = (stc ? 1 : elementCore.bry - elementCore.uly) * tx.h;
                const colorize = !white;
                if (colorize) {
                    // @todo: cache the tint texture for better performance.
                    // Draw to intermediate texture with background color/gradient.
                    // This prevents us from having to create a lot of render texture canvases.
                    // Notice that we don't support (non-rect) gradients, only color tinting for c2d. We'll just take the average color.
                    let color = elementCore.colorUl;
                    if (elementCore.colorUl !== elementCore.colorUr ||
                        elementCore.colorUr !== elementCore.colorBl ||
                        elementCore.colorBr !== elementCore.colorBl) {
                        color = ColorUtils_1.ColorUtils.mergeMultiColorsEqual([
                            elementCore.colorUl,
                            elementCore.colorUr,
                            elementCore.colorBl,
                            elementCore.colorBr,
                        ]);
                    }
                    const alpha = ((color / 16777216) | 0) / 255.0;
                    context.globalAlpha *= alpha;
                    const rgb = color & 0x00ffffff;
                    const tintTexture = this._tintManager.getTintTexture(tx, rgb);
                    // Actually draw result.
                    context.fillStyle = "white";
                    context.drawImage(tintTexture, sourceX, sourceY, sourceW, sourceH, 0, 0, elementCore.getLayoutW(), elementCore.getLayoutH());
                }
                else {
                    context.fillStyle = "white";
                    context.drawImage(tx, sourceX, sourceY, sourceW, sourceH, 0, 0, elementCore.getLayoutW(), elementCore.getLayoutH());
                }
                this._afterDrawEl(info);
                context.globalAlpha = 1.0;
            }
        }
    }
    _setColorGradient(context, core, w = core.getLayoutW(), h = core.getLayoutH(), transparency = true) {
        const color = core.colorUl;
        let gradient;
        if (core.colorUl === core.colorUr) {
            if (core.colorBl === core.colorBr) {
                if (core.colorUl === core.colorBl) {
                    // Single color.
                }
                else {
                    // Vertical gradient.
                    gradient = context.createLinearGradient(0, 0, 0, h);
                    if (transparency) {
                        gradient.addColorStop(0, ColorUtils_1.ColorUtils.getRgbaString(core.colorUl));
                        gradient.addColorStop(1, ColorUtils_1.ColorUtils.getRgbaString(core.colorBl));
                    }
                    else {
                        gradient.addColorStop(0, ColorUtils_1.ColorUtils.getRgbString(core.colorUl));
                        gradient.addColorStop(1, ColorUtils_1.ColorUtils.getRgbString(core.colorBl));
                    }
                }
            }
            else {
                // Not supported gradient.
            }
        }
        else {
            if (core.colorUl === core.colorBl && core.colorUr === core.colorBr) {
                // Horizontal gradient.
                gradient = context.createLinearGradient(0, 0, w, 0);
                if (transparency) {
                    gradient.addColorStop(0, ColorUtils_1.ColorUtils.getRgbaString(core.colorUl));
                    gradient.addColorStop(1, ColorUtils_1.ColorUtils.getRgbaString(core.colorBr));
                }
                else {
                    gradient.addColorStop(0, ColorUtils_1.ColorUtils.getRgbString(core.colorUl));
                    gradient.addColorStop(1, ColorUtils_1.ColorUtils.getRgbString(core.colorBr));
                }
            }
        }
        if (gradient) {
            context.fillStyle = gradient;
        }
        else {
            context.fillStyle = transparency ? ColorUtils_1.ColorUtils.getRgbaString(color) : ColorUtils_1.ColorUtils.getRgbString(color);
        }
    }
    _beforeDrawEl(info) {
        // Noop
    }
    _afterDrawEl(info) {
        // Noop
    }
}
exports.C2dDefaultShader = C2dDefaultShader;
//# sourceMappingURL=C2dDefaultShader.js.map